"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.afterDateFilter = exports.beforeDateFilter = void 0;
const _1 = require(".");
/**
 * Periodsを指定したDate以前でフィルターする
 * NOTE:
 * 現状被ってるものはandで切り出しているが、場合によっては被ってるものは除外したい場合もあるかも？
 * @param date
 * @param periods
 */
const beforeDateFilter = (date, periods) => {
    const filterPreiods = new _1.Periods([new _1.Period(new Date(0), date)]);
    return periods.and(filterPreiods);
};
exports.beforeDateFilter = beforeDateFilter;
/**
 * Periodsを指定したDate以降でフィルターする
 * NOTE:
 * 現状被ってるものはandで切り出しているが、場合によっては被ってるものは除外したい場合もあるかも？
 * @param date
 * @param periods
 */
const afterDateFilter = (date, periods) => {
    const filterPreiods = new _1.Periods([new _1.Period(new Date(0), date)]);
    return periods.not(filterPreiods);
};
exports.afterDateFilter = afterDateFilter;
//# sourceMappingURL=dateFilter.js.map